import Axios from "../../src/helpers/axios";

export const getAllShippingMethods = () => {
  return Axios.get("/api/ecommerce/v1/shippingMethods");
};
